/**
 * Monitoring Dashboard Page
 * Main page for advanced monitoring and observability
 */

import React from 'react';
import MonitoringDashboard from '../../components/monitoring/MonitoringDashboard';

const MonitoringDashboardPage = () => {
  return (
    <div>
      <MonitoringDashboard />
    </div>
  );
};

export default MonitoringDashboardPage;
